﻿import { useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";
import { Bell, ArrowRight } from "lucide-react";

import CustomModalForm from "@/components/desktop/form/modal/CustomModalForm/CustomModalForm";
import CustomButton from "@/components/desktop/button/CustomButton";

import api from "@/services/api.service";

import classes from "./dashboard.module.scss";

const DashboardUpdate = ({ message, show, showModalText, handleClose }) => {
	const navigate = useNavigate();

	const handleCancel = () => {
		api.post("/admin/delete_notification");
		handleClose();
	};

	const handleSubmit = () => {
		api.post("/admin/delete_notification");
		navigate("/soporte/actualizaciones");
	};

	const customFooter = (
		<div className={classes.updateModalFooter}>
			<CustomButton variant="secondary" onClick={handleCancel}>
				Cerrar
			</CustomButton>
			<CustomButton variant="primary" onClick={handleSubmit} endIcon={<ArrowRight size={16} />}>
				Ver Actualización
			</CustomButton>
		</div>
	);

	return (
		<CustomModalForm
			open={show}
			onClose={handleClose}
			title=""
			size="md"
			closeOnBackdrop={false}
			closeOnEsc={false}
			footer={customFooter}
			gridTable={false}
		>
			<div className={classes.updateModalContent}>
				<div className={classes.updateIconWrapper}>
					<div className={classes.updateIconBg}>
						<Bell className={classes.updateIcon} size={28} strokeWidth={2} />
					</div>
				</div>

				<div className={classes.updateTextContent}>
					<h2 className={classes.updateTitle}>Nueva Actualización Disponible</h2>
					{message && <p className={classes.updateMessage}>{message}</p>}

					{showModalText && (
						<div
							className={classes.updateDetails}
							dangerouslySetInnerHTML={{
								__html: DOMPurify.sanitize(showModalText, {
									ADD_TAGS: ["iframe"],
									ALLOWED_TAGS: ["ul", "li", "p", "strong", "em", "br", "span", "div"],
								}),
							}}
						/>
					)}
				</div>
			</div>
		</CustomModalForm>
	);
};

export default DashboardUpdate;
